import { ReviewedDocumentationRepository } from '@/Domain/ReviewedDocumentation/ReviewedDocumentationRepository'
import { AccountId } from '@/Domain/Account'
import { ProcedureId } from '@/Domain/Procedures'
import {
  ReviewedDocumentation,
  ReviewedDocumentationRepositoryError,
  ReviewedDocumentationFactory
} from '@/Domain/ReviewedDocumentation'
import { ApiClient, Api500Error } from '@/Domain/ApiClient'
import { AxiosReviewedDocumentationData } from './AxiosReviewedDocumentationData'

export class AxiosReviewedDocumentationRepository implements ReviewedDocumentationRepository {
  private _apiClient: ApiClient
  private _documentationFactory: ReviewedDocumentationFactory<AxiosReviewedDocumentationData>

  constructor (apiClient: ApiClient, documentationFactory: ReviewedDocumentationFactory<AxiosReviewedDocumentationData>) {
    this._apiClient = apiClient
    this._documentationFactory = documentationFactory
  }

  async byProcedureAndAccountId (procedureCode: ProcedureId, accountId: AccountId): Promise<ReviewedDocumentation> {
    try {
      const response = await this._apiClient.makeGetRequest(
        '/sobree/api/documentation/show/' + procedureCode.id + '/' + accountId.accountId(),
        {}
      )
      return this._documentationFactory.makeReviewedDocumentation(response.data.data)
    } catch (error) {
      if (error instanceof Api500Error) {
        return Promise.reject(new ReviewedDocumentationRepositoryError('Server not responding'))
      }
      return Promise.reject(error)
    }
  }
}
